import React, {ReactNode} from 'react';
import PokerBoard from 'app/components/poker/poker_board/PokerBoard';
import PokerPot from 'app/components/poker/poker_pot/PokerPot';
import PokerPlayers from 'app/components/poker/poker_players/PokerPlayers';
import PokerControllerPanel from 'app/components/poker/poker_controller_panel/PokerControllerPanel';
import PokerMainMessage from 'app/components/poker/poker_main_message/PokerMainMessage';
import PokerPopupJoinTable from 'app/components/poker/poker_popup/PokerPopupJoinTable';
import PokerPopupBuyScroll from 'app/components/poker/poker_popup/PokerPopupBuyScroll';
import {inject, observer} from 'mobx-react';
import {PokerStore} from 'app/store/PokerStore';
import {PokerController} from 'app/controllers/PokerController';
import {UserStore} from 'app/store/UserStore';
import {isDesktop} from 'app/utils';
import {TableModel} from 'app/store/poker/TableModel';

interface Props {
    pokerStore?: PokerStore
    controller?: PokerController
    userStore?: UserStore
    table: TableModel
}

const MIN_LIMIT_MULTIPLIER = 20;
const MAX_LIMIT_MULTIPLIER = 100;
const ExampleNUMBER = 892.5;

@inject('pokerStore', 'controller', 'userStore')
@observer
export default class PokerRoom extends React.Component<Props> {
    table: TableModel;

    constructor(props: Props) {
        super(props);
        this.table = props.table;
        this.state = {
            scale: this.scaleValueTransform()
        };
    }

    scaleValueTransform = (): number => window.innerHeight / ExampleNUMBER;

    handleResize = (): void => {
        this.setState({scale: this.scaleValueTransform()});
    };

    componentDidMount(): void {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.handleResize);
    }

    sitIn = (position: number, amount: number): void => {
        this.props.controller.sitIn(this.table.currentTable.table_id,
            position,
            amount,
            this.table.clearState);
    };

    buyIn = (amount: number): void => {
        this.props.controller.buyIn(this.table.currentTable.table_id,
            amount,
            this.table.clearState);
    };

    render(): ReactNode {
        const {currentTable: {pot, players,
            dealer_place, max_players,
            count_players, action_index,
            finished, is_shutdown, big_blind},
        lastActionParams,
        isSitIn, isBuyIn,
        communityCards, winners, showdownProcessing} = this.table;
        const {isDisabled} = this.props.pokerStore;
        const {is_admin, poker_enabled} = this.props.userStore?.user || {};

        return <div className="poker-room">
            <div className="poker-table" style={{transform: isDesktop() ? 'none' : `scale(${this.scaleValueTransform()})`}}>
                <PokerPot pot={pot}/>
                <PokerBoard cards={communityCards} winners={winners} showdown={showdownProcessing}/>
                <PokerPlayers
                    players={players}
                    dealer_place={dealer_place}
                    max_players={max_players}
                    count_players={count_players}
                    action_index={action_index}
                    previousActionParams={lastActionParams}
                    table={this.table}
                />
            </div>
            <PokerControllerPanel table={this.table}/>
            {(isDisabled && finished || is_shutdown) && <PokerMainMessage/>}
            {!poker_enabled && !is_admin && <PokerPopupBuyScroll table_id={this.table.currentTable.table_id}/>}
            {(isSitIn() || isBuyIn()) &&
                <PokerPopupJoinTable
                    minLimit={big_blind * MIN_LIMIT_MULTIPLIER}
                    maxLimit={big_blind * MAX_LIMIT_MULTIPLIER}
                    onSitIn={this.sitIn}
                    onBuyIn={this.buyIn}
                    isSitIn={isSitIn()}
                    onCancelClick={this.table.clearState}
                    params={this.table.stateParams}
                />}
        </div>;
    }
}
